<template>
  <div>
    <loading :active.sync="isLoading" color="#0B253E"></loading>
    <div id="app">
      <div class="content-wrapper">
        <div class="container-fluid">
          <img class="logo" src="../../../public/assets/img/max_compliance_logo.jpeg" alt>
          <div class="box_general padding_bottom">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Digite o e-mail que será enviado uma nova senha</label>
                  <input type="text"
                    class="form-control"
                    placeholder="E-mail"
                    v-model="email"
                  >
                </div>
              </div>
              <div class="col-md-12 d-flex justify-content-center mt-2">
                <button class="btn_1 medium" type="button" @click="esqueceuSenha()">Enviar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ajax, tratamento_requisicao, alerta } from "../../utils/util";
import funcoesGerais from "../../assets/js/funcoes.js";
export default {
  mixins: [funcoesGerais],
  data: function() {
    return {
      email: "",
      isLoading: false,
    };
  },
  methods: {
    esqueceuSenha() {
      let self = this;
      let subUrl = window.location.hostname
      subUrl = subUrl.split('.')

      if (self.email) {
        self.isLoading = true;
        ajax("put", "alterar_senha", {
          email: self.email,
          subdominio: subUrl[0]
        })
        .then(() => {
          self.isLoading = false;
          alerta('success','Sucesso!',"Sua nova senha será enviada para o seu e-mail!");
          self.$router.replace(self.$route.query.redirect || "/");
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error);
        });
      } else {
        alerta('warning','Atenção',"Preencha o campo");
      }
      return false;
    }
  }
};
</script>
<style scoped>
.box_general {
  display: table;
  margin: 5% auto;
  width: 30%;
}
.content-wrapper {
  margin-left: 0px;
  background-color: #fff;
}
#exampleAccordion {
  display: none;
}
.logo {
  display: table;
  width: 350px;
  margin: 0 auto;
  padding: 10px;
  border-radius: 20px;
  background-color: #0B253E;
}

body {
  background-color: #f8f8f8 !important;
}
</style>
